import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss']
})
export class InputCurrencyComponent implements OnInit {

  @Input() public currency: any = '';
  @Input() public error: any;
  @Input() public disabled: any;
  @Input() public preffix: any;
  @Output() callback: EventEmitter<any> = new EventEmitter;
  noValid:any;


  constructor() { 
    this.noValid=false;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currency && changes.currency.currentValue) {
      //TODO: Format the currency value, when is the firsttime that is used
      //Check this https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-currency-string-in-javascript
      this.format();
    }
  }

  onNgModelChanges($event) { 
    this.format();
    this.emit();
  }

  soloNumeros(e){
    var key = window.event ? e.which : e.keyCode;
    if (key < 48 || key > 57) {
      e.preventDefault();
    }
  }

  format() {
    
    if (!this.currency) {
      return '';
    }
    
    this.noValid = false;

    //Este código se utiliza para ajusta el formato que se alamcena en la variable this.currency.
    //Ya que toma una notación diferente a la que utilizamos (yyy,zzz.xx) en su lugar registra cantidades como (zzzz.xxxx)
    //Con esta lógica adicional, el componente funciona correctamente.
    let currencyCurrent = this.currency.toString();
    let currencyUnformat = currencyCurrent.replace(/,/g,'');
    let cleanedCurrency = '';
    
    if(currencyUnformat.toString().includes('.') > 0){
      let arregloDeSubCadenas = currencyUnformat.split(".");
      
      if(arregloDeSubCadenas[0]){
        cleanedCurrency = cleanedCurrency + arregloDeSubCadenas[0].toString();
      }
      
      if(arregloDeSubCadenas[1]){
        cleanedCurrency = cleanedCurrency + arregloDeSubCadenas[1].toString();
      }
    }
    else
    {
      cleanedCurrency = currencyUnformat;
    }
      
    let strSize = cleanedCurrency.length;
    if(strSize > 2){
      let firstPart = cleanedCurrency.substring(0, (strSize - 2));
      let lastPart = cleanedCurrency.substring((strSize - 2), strSize);
      
      let finalCurrency = firstPart + '.' + lastPart;
      this.currency = finalCurrency;
    }
    else{
      this.currency = cleanedCurrency;
    }

  }

  getUnformat() {
    return this.currency;
  }

  emit() {
    this.callback.emit(this.getUnformat());
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/input-currency/input-currency.component.ts